var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublishIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.66 7.53005L8.59 14.6L4.35 10.36L5.76 8.95005L8.59 11.78L14.25 6.12005L15.66 7.53005ZM2 10C2 7.67005 3.02 5.58005 4.62 4.12005L7 6.50005V0.500049H1L3.2 2.70005C1.24 4.52005 0 7.11005 0 10C0 15.19 3.95 19.4501 9 19.9501V17.93C5.06 17.44 2 14.07 2 10ZM20 10C20 4.81005 16.05 0.550049 11 0.0500488V2.07005C14.94 2.56005 18 5.93005 18 10C18 12.33 16.98 14.42 15.38 15.88L13 13.5V19.5H19L16.8 17.3C18.76 15.48 20 12.89 20 10Z",
    fill: "#2FAD5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishIcon);
export default __webpack_public_path__ + "static/media/publishIcon.9e294c905bb958c5695ebebb19653f35.svg";
export { ForwardRef as ReactComponent };